import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    let headers = request.headers;
    headers = headers.append('Authorization', `Bearer ${token}`);

    if (token) {
      request = request.clone({
        headers: headers
      });
    }

    return next.handle(request);
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptors/token-interceptor.component.ts